module.exports = __webpack_public_path__ + "img/upload.4e6d9a98.svg";